import './experience.scss';
import Swiper from 'swiper/bundle';
export default () => {
	//Swiper
	new Swiper('.js-experience-slider', {
		speed: 500,
		loop: true,
		slidesPerView: 1.2,
		spaceBetween: 20,
		navigation: {
			nextEl: ".experience-button-next",
			prevEl: ".experience-button-prev",
		},
		breakpoints: {
			640: {
				slidesPerView: 2.5,
			},
			1024: {
				slidesPerView: 3,
			},
		},
	});
};
